export default [
    {
        name: "Kg. Batu 9 Kebun Baru",
        lat: 2.9211904,
        lng: 101.48096389999999,
    },
    {
        name: "Kg. Permatang Pasir",
        lat: 2.6542730000000003,
        lng: 101.71751925,
    },
    {
        name: "Kg. Sg. Buaya",
        lat: 2.844623,
        lng: 101.44450485,
    },
]